import { useParams } from "react-router-dom";

export function useUserParams(): { userId: string } {
  return useParams() as { userId: string };
}
